import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import * as _ from "lodash";
import { Request } from "./../api/request";
import { URLS } from "../constants/url.constants";
import { map } from "rxjs/operators";
import { HttpClient, HttpHeaders, HttpRequest } from "@angular/common/http";
import { CommonService } from "../api";

@Injectable({
  providedIn: "root",
})
export class ProviderA2ZService {
  protected environment: any;
  constructor(
    @Inject('AppEnvironment') environmentConfig,
    private request: Request,
    private http: HttpClient,
    private _commonService: CommonService,
  ) {
    this.environment = environmentConfig;
  }


  getProvidersList(event): Observable<any> {


    if(event.direction == 'desc'){
      event.direction = 2;
    }
    else{
      event.direction = 1;
    }

    let url = URLS.x_a2z_apis.getProvidersList+'?limit='+event.pageSize+'&page='+(event.pageIndex+1)+'&searchkey='+event.searchkey+'&order_by='+event.active+'&dir='+event.direction+'&secondary='+event.secondary;

    url = _.replace(url, "{entity}", this._commonService.getEntity());

    return this.request.getApi(url);
  }


  getProvidersFullList(): Observable<any> {

    let url = URLS.provider.getProvidersFullList;
    return this.request.getApi(url);
  }

  saveProviders(values): Observable<any> {
    let url = URLS.x_a2z_apis.createProviders;

    url = _.replace(url, "{entity}", this._commonService.getEntity());

    return this.request.postApi(url, values);
  }

  getAutoCompleteProvidersList(val): Observable<any> {

    let url = URLS.provider.getProvidersFullList+'?searchkey='+val;
    return this.request.getApi(url);
  }


  getAutoCompleteDoctorsList(val,speciality): Observable<any> {

    let url = URLS.provider.getProvidersList+'?searchkey='+val+'&withspeciality='+speciality+'&limit=20';
    return this.request.getApi(url);
  }

  editProviders(id, values): Observable<any> {
    let url = URLS.x_a2z_apis.providersUpdate;

    url = _.replace(url, "{entity}", this._commonService.getEntity());

    url = _.replace(url, "{id}", id);
    return this.request.putApi(url, values);
  }

  deleteProviders(data): Observable<any> {
    let url = URLS.x_a2z_apis.providersDelete;

    url = _.replace(url, "{entity}", this._commonService.getEntity());
    url = _.replace(url, "{id}", data.id);
    return this.request.deleteApi(url);
  }

  PatchProviders(data): Observable<any> {
    let url = URLS.x_a2z_apis.providersPartialUpdate;

    url = _.replace(url, "{entity}", this._commonService.getEntity());
    url = _.replace(url, "{id}", data.provider_id);
    return this.request.patchApi(url,data);
  }

  getProvidersInfo(id, cdate?:any): Observable<any> {
    let url = URLS.x_a2z_apis.providerFetch+'?cdate='+cdate;

    url = _.replace(url, "{entity}", this._commonService.getEntity());
    url = _.replace(url, "{id}", id);
    return this.request.getApi(url);
  }


  getProviderGroupsListAll(): Observable<any> {
    let url = URLS.x_a2z_apis.getProviderGroupsListAll;
    url = _.replace(url, "{entity}", this._commonService.getEntity());
    return this.request.getApi(url);
  }


  getProviderGroupsList(event): Observable<any> {


    if(event.direction == 'desc'){
      event.direction = 2;
    }
    else{
      event.direction = 1;
    }

    let url = URLS.x_a2z_apis.getProviderGroupsList+'?limit='+event.pageSize+'&page='+(event.pageIndex+1)+'&searchkey='+event.searchkey+'&order_by='+event.active+'&dir='+event.direction+'&secondary='+event.secondary;

    url = _.replace(url, "{entity}", this._commonService.getEntity());

    return this.request.getApi(url);
  }

  saveProviderGroups(values): Observable<any> {
    let url = URLS.x_a2z_apis.createProviderGroups;

    url = _.replace(url, "{entity}", this._commonService.getEntity());

    return this.request.postApi(url, values);
  }

  editProviderGroups(id, values): Observable<any> {
    let url = URLS.x_a2z_apis.providerGroupsUpdate;

    url = _.replace(url, "{entity}", this._commonService.getEntity());

    url = _.replace(url, "{id}", id);
    return this.request.putApi(url, values);
  }

  deleteProviderGroups(data): Observable<any> {
    let url = URLS.x_a2z_apis.providerGroupsDelete;

    url = _.replace(url, "{entity}", this._commonService.getEntity());
    url = _.replace(url, "{id}", data.id);
    return this.request.deleteApi(url);
  }

  PatchProviderGroups(data): Observable<any> {
    let url = URLS.x_a2z_apis.providerGroupsPartialUpdate;

    url = _.replace(url, "{entity}", this._commonService.getEntity());
    url = _.replace(url, "{id}", data.provider_id);
    return this.request.patchApi(url,data);
  }

  getProviderGroupsInfo(id, cdate?:any): Observable<any> {
    let url = URLS.x_a2z_apis.providerGroupFetch+'?cdate='+cdate;

    url = _.replace(url, "{entity}", this._commonService.getEntity());
    url = _.replace(url, "{id}", id);
    return this.request.getApi(url);
  }


  getProvidersProfile(uid?:any): Observable<any> {
    let url = URLS.provider.providerinfo+'?user_id='+uid;
    return this.request.getApi(url);
  }

  getProvidersInfo_byUserId(uid): Observable<any> {
    let url = URLS.provider.getProvidersList+'?user_id='+uid;
    return this.request.getApi(url);
  }


  saveUnavailability(values): Observable<any> {
    let url = URLS.unavailability.saveUnavailability;
    return this.request.postApi(url, values);
  }



  getUnavailabilityList(event): Observable<any> {


    if(event.direction == 'desc'){
      event.direction = 2;
    }
    else{
      event.direction = 1;
    }

    let url = URLS.unavailability.getUnavailabilityList+'?limit='+event.pageSize+'&page='+(event.pageIndex+1)+'&searchkey='+event.searchkey+'&order_by='+event.active+'&dir='+event.direction+'&from=' + event.fromdate + '&to=' + event.todate+ '&user_id=' + event.user_id;
    return this.request.getApi(url);
  }


  deleteUnavailability(id): Observable<any> {

    let url = URLS.unavailability.editDeleteUnavailability;
    url = _.replace(url, "{id}", id);
    return this.request.deleteApi(url);
  }

}
